/**
 * @flow
 * @relayHash 7563f4f6534efc454f76219e0081dd0d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StorageClassEnum = "DEEP_ARCHIVE" | "GLACIER" | "RESTORING" | "STANDARD" | "%future added value";
export type DeleteDeliverableFinalFileInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type DeleteDeliverableFinalFileMutationVariables = {|
  input: DeleteDeliverableFinalFileInput
|};
export type DeleteDeliverableFinalFileMutationResponse = {|
  +deleteDeliverableFinalFile: ?{|
    +isDeleted: ?boolean,
    +deliverable: ?{|
      +id: string,
      +finalFiles: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +created: any,
            +fileName: string,
            +fileSize: ?number,
            +description: ?string,
            +fileUrl: ?string,
            +storageClass: ?StorageClassEnum,
          |}
        |}>
      |},
    |},
  |}
|};
export type DeleteDeliverableFinalFileMutation = {|
  variables: DeleteDeliverableFinalFileMutationVariables,
  response: DeleteDeliverableFinalFileMutationResponse,
|};
*/


/*
mutation DeleteDeliverableFinalFileMutation(
  $input: DeleteDeliverableFinalFileInput!
) {
  deleteDeliverableFinalFile(input: $input) {
    isDeleted
    deliverable {
      id
      finalFiles(orderBy: "-created") {
        edges {
          node {
            id
            created
            fileName
            fileSize
            description
            fileUrl
            storageClass
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteDeliverableFinalFileInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteDeliverableFinalFile",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDeliverableFinalFilePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deliverable",
        "storageKey": null,
        "args": null,
        "concreteType": "DeliverableNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "finalFiles",
            "storageKey": "finalFiles(orderBy:\"-created\")",
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "-created"
              }
            ],
            "concreteType": "DeliverableFinalFileNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DeliverableFinalFileNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DeliverableFinalFileNode",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "created",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fileName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fileSize",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fileUrl",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "storageClass",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteDeliverableFinalFileMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteDeliverableFinalFileMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteDeliverableFinalFileMutation",
    "id": null,
    "text": "mutation DeleteDeliverableFinalFileMutation(\n  $input: DeleteDeliverableFinalFileInput!\n) {\n  deleteDeliverableFinalFile(input: $input) {\n    isDeleted\n    deliverable {\n      id\n      finalFiles(orderBy: \"-created\") {\n        edges {\n          node {\n            id\n            created\n            fileName\n            fileSize\n            description\n            fileUrl\n            storageClass\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '203885c7a706b01a0beb71eeba887c0a';
module.exports = node;
